module.exports = __webpack_public_path__ + "img/arrow-pagination-all.baa94546.svg";